import { getSessionStore } from "app/utils/sessionStore";
import { THEME } from "app/utils/types";

/**
 * Picks primary/secondary from branding for the current session theme.
 * Dark mode uses *ColorDark fields, falling back to light colors when empty.
 */
export const getThemedPrimarySecondaryFromSource = (
  source: any,
  fallbackPrimary: string,
  fallbackSecondary: string,
): { primaryColor: string; secondaryColor: string } => {
  const isDark = getSessionStore("globalTheme") === THEME.DARK;
  const trimColor = (v: any) => {
    if (v === undefined || v === null) return "";
    return String(v).trim();
  };
  const lightPrimary = trimColor(source?.primaryColor) || fallbackPrimary;
  const lightSecondary = trimColor(source?.secondaryColor) || fallbackSecondary;
  if (!isDark) {
    return { primaryColor: lightPrimary, secondaryColor: lightSecondary };
  }
  const darkP = trimColor(source?.primaryColorDark);
  const darkS = trimColor(source?.secondaryColorDark);
  return {
    primaryColor: darkP || lightPrimary,
    secondaryColor: darkS || lightSecondary,
  };
};
